export var AssetEmbedType;
(function (AssetEmbedType) {
    AssetEmbedType["ASSET_URL"] = "assetURL";
    AssetEmbedType["PID"] = "pid";
    AssetEmbedType["CID"] = "contentId";
})(AssetEmbedType || (AssetEmbedType = {}));
